let pendingBankExtractionFile: File | null = null;

export const setPendingBankExtractionFile = (file: File | null) => {
  pendingBankExtractionFile = file;
};

export const getPendingBankExtractionFile = () => pendingBankExtractionFile;

export const clearPendingBankExtractionFile = () => {
  pendingBankExtractionFile = null;
};
